import React from "react";
import { useTranslation } from "react-i18next";
import { Caption2, Dialog, Header3 } from "@activecollab/components";
import PropTypes from "prop-types";
import { LanguagePicker } from "~/pages/Onboarding/LanguagePicker";

export const SetPasswordDialog = ({ title, className, children }) => {
  const { t } = useTranslation();
  return (
    <>
      <Dialog.Title
        className="tw-flex tw-flex-col sm:tw-flex-row tw-justify-between tw-items-start sm:tw-items-center tw-gap-4 sm:tw-gap-0"
        disableDefaultHeading
      >
        <div className="tw-flex tw-flex-col">
          <Caption2 color="secondary">{t("Welcome to ActiveCollab")}</Caption2>
          <Header3>{title}</Header3>
        </div>
        <LanguagePicker />
      </Dialog.Title>
      <Dialog.ContentDivider />
      <Dialog.Content className={className}>{children}</Dialog.Content>
      <Dialog.ContentDivider />
    </>
  );
};

SetPasswordDialog.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

SetPasswordDialog.defaultProps = {
  className: "",
};

export default SetPasswordDialog;
